import * as actionTypes from "../actions/actionTypes";
import { CA_fieldPatterns } from "../../util/cbsaFieldpatterns";
import { getValidationError } from "../../util";
import _ from "lodash";
import { CAProvinces, usStates } from "./util";
import { getHSDetail } from "../api/htsRequests";

const initialState = {
  headerWarning: [],
  partiesWarning: [],
  errorWarning: [],
  invoiceWarning: [],
  lineWarning: [],
};



export default function FormValidationReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.INIT_HEADER_TAB_WARNINGS: {
      const headerElements = action.rest;
      let newState = { ...state };
      newState.headerWarning = validateHeaderFields(
        headerElements,
        action.parentShipmentId,
        action?.formType,
        action?.isGoodRealesed
      );

      return newState;
    }

    case actionTypes.INIT_PARTIES_TAB_WARNINGS: {
      let newState = { ...state };
      const Elements = action.rest;
      newState.partiesWarning = validatePartiesFields(Elements);
      return newState;
    }

    case actionTypes.INIT_INVOICE_TAB_WARNINGS: {
      let newState = { ...state };
      const Elements = action.rest;
      newState.invoiceWarning = validateInvoiceFields(Elements);
      return newState;
    }
    case actionTypes.INVOICE_WARNING_ON_ADDITION: {
      let newState = { ...state };
      const Elements = action.errorsList;
      newState.invoiceWarning = Elements;
      return newState;
    }

    case actionTypes.INIT_LINE_TAB_WARNINGS: {
      let newState = { ...state };
      const Elements = action.rest;
      newState.lineWarning = validateLineFields(Elements);
      return newState;
    }
    case actionTypes.REMOVE_WARNING_ON_DELETEION_INVOICE: {
      let newState = { ...state };
      let lineWarning = newState.lineWarning;
      let invoiceWarning = newState.invoiceWarning;
      let new_lineWarning = lineWarning.filter(
        (item) => item.invoiceId !== action.invoiceId
      );
      // console.log("new_lineWarning", new_lineWarning);
      let new_InvoiceWarning = invoiceWarning.filter(
        (item) => item.invoiceId !== action.invoiceId
      );
      newState["invoiceWarning"] = new_InvoiceWarning;
      newState["lineWarning"] = new_lineWarning;
      return newState;
    }
    case actionTypes.REMOVE_WARNING_ON_DELETEION_MERCH: {
      let newState = { ...state };
      let lineWarning = newState.lineWarning;
      let new_lineWarning = lineWarning.filter(
        (item) => item.merchandiseId !== action.merchandiseId
      );
      newState["lineWarning"] = new_lineWarning;
      return newState;
    }

    // case actionTypes.INIT_ITEM_TAB_WARNINGS: {
    // //   const invoiceElemnets = action.invoices;
    // //   const declarationType = action.declarationType;
    // //   const invoiceFormElemets = action.payload;
    //   let newState = { ...state };
    // //   let errors = validateItemFields(
    // //     invoiceElemnets
    // //   );
    // //   let data = [...errors];
    // //   let sortedData = _.orderBy(data, ["key"], ["asc"]);

    // //   newState.errorWarning = sortedData;
    // //   console.log(newState.errorWarning, "errorWarning");
    //   return newState;
    // }

    case actionTypes.UPDATE_HEADER_WARNINGS: {
      let newState = { ...state };
      let findIdx =
        newState.headerWarning &&
        newState.headerWarning.findIndex((_item) => {
          return _item["fieldName"] === action.field;
        });
      if (findIdx && findIdx === -1) {
        newState["headerWarning"].push({
          fieldName: action.field,
          msg: action.value,
        });
      } else {
        newState.headerWarning.map((item) => {
          if (item["fieldName"] === action.field) item["msg"] = action.value;
        });
      }

      return newState;
    }

    case actionTypes.REMOVE_HEADER_WARNINGS: {
      let newState = { ...state };
      let headerWarning = newState.headerWarning;
      headerWarning = headerWarning.filter((item) => {
        return item.fieldName !== action.field;
      });
      newState["headerWarning"] = headerWarning;
      return newState;
    }

    case actionTypes.UPDATE_PARTIES_WARNINGS: {
      let newState = { ...state };
      let findIdx =
        newState.partiesWarning &&
        newState.partiesWarning.findIndex((_item) => {
          return (
            _item["fieldName"] &&
            _item["fieldName"].toLowerCase() === action.field.toLowerCase()
          );
        });
      if (findIdx && findIdx === -1) {
        newState["partiesWarning"].push({
          fieldName: action.field,
          msg: action.value,
        });
      } else {
        newState.partiesWarning.map((item) => {
          if (
            item["fieldName"] &&
            item["fieldName"].toLowerCase() === action.field.toLowerCase()
          )
            item["msg"] = action.value;
        });
      }

      return newState;
    }

    case actionTypes.REMOVE_PARTIES_WARNINGS: {
      let newState = { ...state };
      let partiesWarning = newState.partiesWarning;
      partiesWarning = partiesWarning.filter((item) => {
        return (
          item.fieldName &&
          item.fieldName.toLowerCase() !== action.field.toLowerCase()
        );
      });
      newState["partiesWarning"] = partiesWarning;
      return newState;
    }
    case actionTypes.UPDATE_INVOICE_WARNINGS: {
      let newState = { ...state };
      let findIdx =
        newState.invoiceWarning &&
        newState.invoiceWarning.findIndex((_item) => {
          return (
            _item.invoiceId === action.invoiceId &&
            _item["fieldName"] &&
            _item["fieldName"].toLowerCase() === action.field.toLowerCase()
          );
        });
      if (findIdx && findIdx === -1) {
        newState["invoiceWarning"].push({
          fieldName: action.field,
          msg: action.value.join(", "),
          invoiceId: action.invoiceId,
        });
      } else {
        newState.invoiceWarning.map((item) => {
          if (
            item["fieldName"] &&
            item["fieldName"].toLowerCase() === action.field.toLowerCase() &&
            item["invoiceId"] === action.invoiceId
          ) {
            item["msg"] = action.value.join(", ");
          }
        });
      }
      return newState;
    }
    case actionTypes.REMOVE_INVOICE_WARNINGS: {
      let newState = { ...state };
      let invoiceWarning = newState.invoiceWarning;
      invoiceWarning = invoiceWarning.filter((item) => {
        if (item.invoiceId === action.invoiceId) {
          return (
            item.fieldName &&
            item.fieldName.toLowerCase() !== action.field.toLowerCase()
          );
        } else {
          return true;
        }
      });
      newState["invoiceWarning"] = invoiceWarning;
      //console.log("invoiceWarning", newState);
      return newState;
    }
    case actionTypes.UPDATE_LINE_WARNINGS: {
      let newState = { ...state };
      let findIdx =
        newState.lineWarning &&
        newState.lineWarning.findIndex((_item) => {
          return (
            _item.merchandiseId === action.merchandiseId &&
            _item["fieldName"] &&
            _item["fieldName"].toLowerCase() === action.field.toLowerCase()
          );
        });
      if (findIdx && findIdx === -1) {
        newState["lineWarning"].push({
          fieldName: action.field,
          msg: action.value.join(", "),
          invoiceId: action.invoiceId,
          merchandiseId: action.merchandiseId,
        });
      } else {
        newState.lineWarning.map((item) => {
          if (
            item["fieldName"] &&
            item["fieldName"].toLowerCase() === action.field.toLowerCase() &&
            item["invoiceId"] === action.invoiceId &&
            item["merchandiseId"] === action.merchandiseId
          ) {
            item["msg"] = action.value.join(", ");
            item["invoiceId"] = action.invoiceId;
            item["merchandiseId"] = action.merchandiseId;
          }
        });
      }
      return newState;
    }
    case actionTypes.REMOVE_LINE_WARNINGS: {
      let lineWarnings = [...state.lineWarning].filter((item) => {
        if (item.merchandiseId === action.merchandiseId) {
          if (item.fieldName && item.fieldName === action.field) {
            return false;
          }
          return true;
        } else {
          return true;
        }
      });

      return {
        ...state,
        lineWarning: lineWarnings,
      };
    }

    default:
      return state;
  }
}

const validateHeaderFields = (headerElements, parentShipmentId, formType, isGoodRealesed) => {
  // console.log({validateHeaderFields_isGoodRealesed:isGoodRealesed})
  let errors = [];

  if (!headerElements) {
    return [];
  }
  let headerPattern = Object.entries(CA_fieldPatterns.Shipment);
  headerPattern.map((item) => {
    if (
      !parentShipmentId ||
      (parentShipmentId && item[0] !== "transactionNo")
    ) {
      let fieldName = item[0];
      if (
        (fieldName === "estimateArrivalDate" || fieldName === "releaseDate") &&
        headerElements[fieldName].epochs
      ) {
        headerElements[fieldName] = headerElements[fieldName].epochs;
      }
      if (
        (fieldName === "totalPiece" || fieldName === "weight") &&
        headerElements[fieldName].qty
      ) {
        headerElements[fieldName] = headerElements[fieldName].qty;
      }
      let err = getValidationError(
        fieldName,
        headerElements[fieldName],
        "Shipment",
        undefined,
        fieldName === "portOfUnlading"
          ? { modeOfTransport: headerElements.modeOfTransport }
          : (fieldName === "amendmentReasonCode"&& formType==='CARM') ?  { transmissionType: headerElements.transmissionType, isGoodRealesed }: undefined
      );
      if (err[0]) {
        errors.push({ fieldName: fieldName, msg: err.join(", ") });
      }      
    }
  });
  return errors;
};

const validateItemFields = (headerElements) => {
  let errors = [];

  if (!headerElements) {
    return [];
  }
  let headerPattern = Object.entries(CA_fieldPatterns.Invoice);
  headerPattern.map((item) => {
    let fieldName = item[0];
    let err = getValidationError(
      fieldName,
      headerElements[fieldName],
      "Invoice"
    );
    errors.push(err);
  });
  return errors;
};



const validatePartiesFields = (elements) => {
  let errors = [];
  let partiesFields = [
    "importerName",
    "importerNo",
    "importerAddress",
    "importerCity",
    "importerState",
    "importerZip",
    "consigneeName",
    "consigneeNo",
    "consigneeAddress",
    "consigneeCity",
    "consigneeState",
    "consigneeZip",
  ];
  partiesFields.map((item) => {
    let fieldName = item;
    let value = elements[item];
    let err = getValidationError(
      fieldName,
      value,
      "Actor",
      undefined,
      fieldName === "importerState"
        ? { importerCountry: elements["importerCountry"] }
        : undefined
    );
    if(item === 'consigneeState' && elements['consigneeCountryCode'] === 'CA'){
      if(!CAProvinces.includes(elements[item])){
        errors.push({ tab: "Parties", fieldName: item, msg:'Please select correct State/Province Consignee' });

      }

    }
    if(item === 'importerState' && elements['importerCountryCode'] === 'CA'){
      if(!CAProvinces.includes(elements[item])){
        errors.push({ tab: "Parties", fieldName: item, msg:'Please select correct State/Province for Importer' });
      }

    }
    if (err[0]) {
      errors.push({ tab: "Parties", fieldName: item, msg: err.join(", ") });
    }
  });
  return errors;
};


export const checkCountryStateMapping = (country, state) => {
  if (country == 'CA' && state) {
    if (!CAProvinces.includes(state.toUpperCase())) {
      return true
    }
  } else if ((country == 'US' || country == 'USA') && state) {
    if (!!usStates && !usStates.includes(state.toUpperCase())) {
      return true
    }
  }
};
export const validateInvoiceFields = (elements) => {
  let countries = ["USA", "US", "CA"];
  let errors = [];
  elements.forEach((elem) => {
    let invoicePattern = Object.entries(CA_fieldPatterns.Invoice);
    invoicePattern.map((item) => {
      let fieldName = item[0];
      if (
        (
          fieldName === "netWeight" ||
          fieldName === "package") &&
        elem[fieldName].qty
      ) {
        elem[fieldName] = elem[fieldName].qty;
      }
      if (
        (fieldName === "invoiceDate" || fieldName === "directShipmentDate") &&
        elem[fieldName].epochs
      ) {
        elem[fieldName] = elem[fieldName].epochs;
      }
      let fieldValue = elem[fieldName];

      if(fieldName === 'grossWeight'){
          if(elem[fieldName]?.qty === -999 && elem['totalUnit']?.qty===-999){
            errors.push({
              tab: "Invoice",
              fieldName:'grossWeight',
              msg: `Gross weight or total unit count is mandatory`,
              invoiceId: elem["invoiceId"],
            });
          }
      }
        
      if (fieldName === "vendorAddress") {
        fieldValue = elem["addressInfo"]["STREET_NAME"];
        if (fieldValue?.trim().length < 1) {
          fieldValue = "";
        }
      } else if (fieldName === "vendorCity") {
        fieldValue = elem["addressInfo"]["CITY"];
      } else if (fieldName === "vendorState") {
        let valCountry = elem["addressInfo"]["COUNTRY_SUB_ENTITY"] || "";

        if (!countries.includes(valCountry)) {
          fieldValue = elem["addressInfo"]["COUNTRY_SUB_ENTITY"];
        }
      } else if (fieldName === "vendorZip") {
        let valCountry = elem["addressInfo"]["POSTAL_CODE"] || "";
        if (!countries.includes(valCountry)) {
          fieldValue = elem["addressInfo"]["POSTAL_CODE"];
        }
      } else if (fieldName === "vendorCountry") {
        fieldValue = elem["addressInfo"]["COUNTRY"];
      }
       const fields={"vendorZip":"POSTAL_CODE","vendorState":"COUNTRY_SUB_ENTITY"}
      if(Object.keys(fields).includes(fieldName)){
        if(countries.includes(elem["addressInfo"]["COUNTRY"]) && !elem["addressInfo"][fields[fieldName]]){
          errors.push({
            tab: "Invoice",
            fieldName: fieldName,
            msg: `Vendor ${fieldName.slice(6)} is mandatory`,
            invoiceId: elem["invoiceId"],
          });
        }
      }
      if(fieldName=="vendorState"){
        if(elem["addressInfo"]["COUNTRY"] && checkCountryStateMapping(elem["addressInfo"]["COUNTRY"],elem["addressInfo"]["COUNTRY_SUB_ENTITY"])){
          errors.push({
            tab: "Invoice",
            fieldName: fieldName,
            msg: `State does not correspond to the selected country`,
            invoiceId: elem["invoiceId"],
          });
        }
      }
      let err = getValidationError(fieldName, fieldValue, "Invoice");
      if (err[0]) {
        errors.push({
          tab: "Invoice",
          fieldName: fieldName,
          msg: err.join(", "),
          invoiceId: elem["invoiceId"],
        });
      }
    });
  });
  return errors;
};

const validateLineFields = (elements) => {
  let errors = [];
  elements.forEach((elem) => {
    let linePattern = Object.entries(CA_fieldPatterns.Merchandise);
    linePattern.map((item) => {
      let fieldName = item[0];
      if(fieldName=='quantity' && elem['unitOfMeasurement']=='Kilogram'){
        if (!/^\d+(\.\d{1,4})?$/.test(elem[fieldName])) {
          errors.push({
          tab: "Merchandise",
          fieldName: 'quantity',
          msg: 'Quantity can only contain floating point numbers till 4 decimal points',
          invoiceId: elem["invoiceId"],
          merchandiseId: elem["merchandiseId"],
            
        });
        }
      }
      
      if(fieldName === 'classificationNo'){
         getHSDetail({
           hts: elem[fieldName],
           tariffTreatments:elem['tariffTreatment'],
         }).then((response) => {
           if (
             response.data.eventMessage.header &&
             response.data.eventMessage.header.code
           ) {
            errors.push({
              tab: "Merchandise",
              fieldName: 'classificationNo',
              msg:'Invalid HS Code',
              invoiceId: elem["invoiceId"],
              merchandiseId: elem["merchandiseId"],
                
            })
           }
         });
      }
      let err = getValidationError(fieldName, elem[fieldName], "Merchandise");
      if (err[0] && !(fieldName === "quantity" && elem['unitOfMeasurement'] === "Kilogram")) {
       
        errors.push({
          tab: "Merchandise",
          fieldName: fieldName,
          msg: err.join(", "),
          invoiceId: elem["invoiceId"],
          merchandiseId: elem["merchandiseId"],
        });
      }
    });
  });

  return errors;
};
